import { f as _inherits, g as _createSuper, b as _classCallCheck, c as _defineProperty, h as _assertThisInitialized, a as _createClass, i as _wrapNativeSuper } from './wrapNativeSuper-88131596.esm.js';
import 'core-js/modules/es.number.is-integer.js';
import 'core-js/modules/es.number.constructor.js';

var defaultTranscodingProfiles = [{
  name: '720p',
  bitrate: 2000000,
  fps: 30,
  width: 1280,
  height: 720
}, {
  name: '480p',
  bitrate: 1000000,
  fps: 30,
  width: 854,
  height: 480
}, {
  name: '360p',
  bitrate: 500000,
  fps: 30,
  width: 640,
  height: 360
}];
var defaultStudioConfig = {
  name: 'Livepeer Studio',
  baseUrl: 'https://livepeer.studio/api',
  apiKey: 'a616be3b-8980-4932-8079-0122e0106f95'
};

/**
 * Error subclass for http errors.
 */
var HttpError = /*#__PURE__*/function (_Error) {
  _inherits(HttpError, _Error);

  var _super = _createSuper(HttpError);

  function HttpError(
  /** Number error code */
  code,
  /** Human-readable string */
  message,
  /** Low-level error */
  internal,
  /** Other useful information about error */
  data) {
    var _this;

    _classCallCheck(this, HttpError);

    if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
    if (!message || typeof message !== 'string') throw new Error('"message" must be a nonempty string.');
    _this = _super.call(this, message);

    _defineProperty(_assertThisInitialized(_this), "code", void 0);

    _defineProperty(_assertThisInitialized(_this), "data", void 0);

    _defineProperty(_assertThisInitialized(_this), "internal", void 0);

    _this.code = code;
    _this.data = data;
    _this.internal = internal;
    return _this;
  }

  return _createClass(HttpError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

export { HttpError as H, _arrayLikeToArray as _, _unsupportedIterableToArray as a, defaultStudioConfig as b, defaultTranscodingProfiles as d };
